module.exports = __webpack_public_path__ + "static/img/zijianCompany.7b198b3a.jpg";